import { getDatasWithOption } from '../../utils/service';
import { BREAKPOINTS } from '../../model/model';
import { isChrome, isDefined, isObject, not, isNotDefined, each, truthy, falsy, parseInt10, isMobileResolution, getResolution } from '../../utils/util';
import SettingModel from './tpl';

class BeginnerItem {
  constructor(options) {
    const _ = this;

      if (!options) return;
      _.option = $.extend({
          wrap: null,
          apiDomain: '',
          classId: 0,
          level: 1,
          isLogin: false,
          global: window
      }, options);

      _.model = new SettingModel;
    _.global = (_.option.global) ? _.option.global : window;

  }

  init() {
      const _ = this;
      console.log('BeginnerItem init !! ');

    _.setData();

    /*
    if (truthy(_.option.isLogin)) {
      if (isDefined(_.option.wrap) && _.option.wrap.length) _.setData();
    }
    return _;
    */

  }

  setData() {
    const _ = this,
        _level = _.option.level,
        _classId = _.option.classId;

  getDatasWithOption([{
      type: 'GET',
      url: `${_.option.apiDomain}/api/returnbrave/recommend/item/${_classId}`,
      dataType: 'json'
    }], (data) => {
      _.setInstance(data);
    }, (data) => {
      // no process
    });

  }


  setInstance(data){
    const _ = this,
        _level = _.option.level,
        _classId = _.option.classId,
        _wrap = _.option.wrap.itemWrap;
    let _data = data.itemRecommend;


      if (!Object.keys) {
          Object.keys = function(obj) {
              var keys = [];

              for (var i in obj) {
                  if (obj.hasOwnProperty(i)) {
                      keys.push(i);
                  }
              }
              return keys;
          };
      }

      if (!Object.values) {
          Object.values = function(obj) {
              var values = [];
              for (var i in obj) {
                  if (obj.hasOwnProperty(i)) {
                      values.push(obj[i]);
                  }
              }
              return values;
          };
      }



    let itemTpl ='';
    let itemTypes = Object.keys(_.model.ITEM_NAMES);
    let itemValues = Object.values(_.model.ITEM_NAMES);


    // 입수법
    let acqTypes = Object.keys(_.model.ACQUISITION_NAMES);
    let itemAcquisitionDisplay = function(acquisition) {

        let acquisitionDom = $('<span class="acq"></span>');

        let acquisitionTpl = `<i class="acq-Quest">Q</i><i class="acq-NPC">N</i><i class="acq-Making">M</i><i class="acq-Drop">D</i>`;
        acquisitionDom.append(acquisitionTpl);

        acquisition.map((acquisitionItem, acquisitionIdx) => {
          acquisitionDom.find(`.acq-${acquisitionItem}`).addClass('on');
        });
        return acquisitionDom.html();

    } // itemAcquisitionDisplay function()


    itemTypes.map( (item,index) => {
      let itemName = _.model.ITEM_NAMES[item]; // ex. 무기

        itemTpl += `<div class="item-card ${item}">
              <h3>${itemName}</h3><ul>`;

        _data[item].map( (itemData, itemIndex) => {

            if(itemIndex > 5 ) return;
            itemTpl += `<li>
                        <span class="item-card__name"><a class="grade-${itemData.itemQuality}" href="${itemData.itemWikiUrl}">${itemData.itemName}</a></span>
                        <span class="item-card__acquisition">${itemAcquisitionDisplay(itemData.acquisition)}</span>
                    </li>
                `;
        });
        itemTpl += `</ul></div>`;
    });
    // console.log('html : ', itemTpl);

    $('.article-item', _wrap).append( itemTpl );

      _.setSlick( $('.article-item', _wrap) );


  } // setInstance()


  setSlick(_wrap){
    const _ = this;

    let itemSlider = _wrap;
    itemSlider.slick({
        dots: true,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 3840,
                settings: "unslick"
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: false,
                    centerPadding: '0'
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '40px'
                }
            }
        ]
    });
    $(window).resize(function() {
        itemSlider.slick('resize');
    });

  } // setSlick()

}

export default BeginnerItem;


// WEBPACK FOOTER //
// ./_src/js/service/beginner/BeginnerItem.js